import { useCallback, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { briefIsInMotion, briefMessageAgentId, briefMessageAgentName, fetchMorningBrief, isBriefSummaryTurn } from '../brief';
import { queryKeys } from '../query-client';
import { useDuplexer } from '../use-duplexer';
import { useLoadBi } from '../use-load-bi';
import type { WorldMeeting } from './world-meeting';

export function useWorldMeeting(active: boolean) {
  const query = useQuery({ queryKey: queryKeys.brief, queryFn: fetchMorningBrief, enabled: active,
    refetchInterval: brief => active ? brief && briefIsInMotion(brief) ? 10_000 : 30_000 : false });
  useDuplexer(useCallback(entity => {
    if (active && entity.conversationId === query.data?.conversationId) void query.refetch();
  }, [active, query.data?.conversationId, query.refetch]));
  useLoadBi('home-world-meeting', { isLoading: active && query.isLoading, isError: query.isError });
  const meeting = useMemo<WorldMeeting | undefined>(() => {
    const brief = query.data;
    if (!brief || query.isError) return;
    return { id: brief.conversationId, title: brief.name || '', startedAt: Date.parse(brief.generatedDate), finished: brief.active, failed: brief.failed,
      turns: brief.messages.map(message => ({ id: message.id, at: Date.parse(message.createdDate), agentId: briefMessageAgentId(message),
        agentName: briefMessageAgentName(message), text: message.content, summary: isBriefSummaryTurn(message) })) };
  }, [query.data, query.isError]);
  return { meeting, loading: query.isLoading };
}
